import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core'
import React from 'react'
import { Pressable, Text, TouchableOpacity, View } from 'react-native'
import { TabSearch } from '../../service-inquiry/basic-search-form'
import { useTranslation } from 'react-i18next'
import { BasicSearchConst } from '../BasicSearchConst'
import { Category, Permission, PulseOpsFormat, SelectOption, TaskOp, TransactionLabel, TransactionStatus, TransactionStatusLabel, TransactionType } from '@pulseops/common'
import { DrawerContentComponentProps, DrawerContentOptions } from '@react-navigation/drawer'
import { basicSharedStyles } from '../BasicSharedStyles'
type AdminClaimSearchTableProps = {
  rows: TaskOp[]
  roles: string[]
  selectedTab: TabSearch
  pageNum: number
  setPageNum: (pageNum: number) => void
  pageSize: number
  setPageSize: (pageSize: number) => void
  totalItem: number
  sortItem: { field: string; order: 'asc' | 'desc' | undefined }
  setSortItem: (sortItem: { field: string; order: 'asc' | 'desc' | undefined }) => void
  parentNavigation: DrawerContentComponentProps<DrawerContentOptions>
  queryServiceInquiryList: (pageSize: number, pageNum: number) => void
}

export const AdminClaimSearchTable = (props: AdminClaimSearchTableProps) => {
  const { t } = useTranslation()
  const classes = BasicSearchConst.makeBasicStyles()
  const [subServiceTypeList, setSubServiceTypeList] = React.useState<SelectOption[]>([])
  const [subTransactionTypeList, setSubTransactionTypeList] = React.useState<(SelectOption & { typeCode: string })[]>(
    []
  )
  const {
    rows,
    roles,
    selectedTab,
    pageNum,
    setPageNum,
    pageSize,
    setPageSize,
    totalItem,
    parentNavigation,
    queryServiceInquiryList
  } = props

  return (
    <View style={basicSharedStyles.container}>
      <TableContainer component={Paper} style={{ maxHeight: 500 }} elevation={1}>
        <Table style={{ userSelect: 'text' }} stickyHeader>
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:CaseID')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Status')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:CurrentActivity')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Source')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:PolicyNumber')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:POClient')}</TableCell>
              {[TabSearch.TraditionalClaimSearch].includes(selectedTab) && (
                <>
                  <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:POID')}</TableCell>
                  <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:POName')}</TableCell>
                  <TableCell className={classes.tableCell}>
                    {t('ServiceInquiry:table:POPhoneNumber')}
                  </TableCell>
                </>
              )}
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Category')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Transaction')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Request')}</TableCell>
              {[TabSearch.TraditionalClaimSearch].includes(selectedTab) && (
                <>
                  <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Service')}</TableCell>
                  <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Group')}</TableCell>
                  <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:SubService')}</TableCell>
                  <TableCell className={classes.tableCell}>
                    {t('ServiceInquiry:table:SubTransaction')}
                  </TableCell>
                </>
              )}
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:UserSubmission')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:CreatedDate')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Aging')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:LastUpdatedDate')}</TableCell>
              {[TabSearch.TraditionalClaimSearch].includes(selectedTab) && (
                <>
                  <TableCell className={classes.tableCell}>
                    {t('ServiceInquiry:table:LastAssignee')}
                  </TableCell>
                </>
              )}
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:LastUpdatedBy')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Note')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={`TableRow-${i}`}>
                {/* CaseID */}
                <TableCell>
                  {row.caseId &&
                    roles.includes(Permission['ViewDetailServiceInquiry']) &&
                    ((['PULSE4OPS', 'PULSE', 'BANCA_SEA', 'LANDING_PAGE', 'PRUONLINE'].includes(row.source) &&
                      row.transactionType !== 'UPLOAD_DOCUMENT') ||
                      (['EKIOSK', 'ZALO'].includes(row.source) && row.transactionType === 'COMPLAINT')) ? (
                    <Pressable
                      onPress={() =>
                        parentNavigation.navigation.navigate('TaskDetailStack', {
                          screen: 'TaskDetailScreen',
                          params: {
                            id: row.id,
                            caterogy: row.category,
                            basket: '',
                            basketName:
                              selectedTab === TabSearch.AdminClaimSearch
                                ? row.transactionType === TransactionType.PAYOUT
                                  ? 'CL-PV'
                                  : row.status === TransactionStatus.IN_PROGRESS &&
                                    row.activity === '6. Verification'
                                    ? 'CL-VER'
                                    : 'CL-ADJ'
                                : '',
                            isInquiry: '1',
                            isHistory: 'true',
                            isBreadcrumb: '1',
                            hasArchivedHistoryView: '1'
                          }
                        })
                      }
                    >
                      <Text style={[{ color: '#ed1b2e' }, basicSharedStyles.cellNoWrap]}>{row.caseId}</Text>
                    </Pressable>
                  ) : (
                    <Text style={basicSharedStyles.cellNoWrap}>{row.caseId || '-'}</Text>
                  )}
                </TableCell>
                {/* Status */}
                <TableCell
                  style={{ color: TransactionStatusLabel(row.status).color }}
                  className={classes.cellNoWrap}
                >
                  {TransactionStatusLabel(row.status).label}
                </TableCell>
                {/* CurrentActivity */}
                <TableCell>{row.activity || '-'}</TableCell>
                {/* Source */}
                <TableCell>{row.source}</TableCell>
                {/* PolicyNumber */}
                <TableCell>{row.policyNumber || '-'}</TableCell>
                {/* POClient */}
                <TableCell>{row.clientNumber || '-'}</TableCell>
                {[TabSearch.TraditionalClaimSearch].includes(selectedTab) && (
                  <>
                    {/* POID */}
                    <TableCell>{row.poClientNumber || '-'}</TableCell>
                    {/* POName */}
                    <TableCell>{row.poName || '-'}</TableCell>
                    {/* POPhoneNumber */}
                    <TableCell>{row.poPhoneNumber || '-'}</TableCell>
                  </>
                )}
                {/* Category */}
                <TableCell className={classes.cellNoWrap}>
                  {BasicSearchConst.convertCategoryToLabel(row.category) || '-'}
                </TableCell>

                {/* Transaction */}
                <TableCell className={classes.cellNoWrap}>
                  {t(TransactionLabel(row.transactionType))}
                </TableCell>
                {/* Request */}
                <TableCell className={classes.cellNoWrap}>-</TableCell>
                {[TabSearch.TraditionalClaimSearch].includes(selectedTab) && (
                  <>
                    {/* Service */}
                    <TableCell>{'-'}</TableCell>
                    {/* Group */}
                    <TableCell>{'-'}</TableCell>
                    {/* SubService */}
                    <TableCell>
                      {subServiceTypeList.find((x) => x.value === row.subServiceType)?.label || '-'}
                    </TableCell>
                    {/* SubTransaction */}
                    <TableCell>
                      {subTransactionTypeList.find((x) => x.value === row.subTransactionType)?.label || '-'}
                    </TableCell>
                  </>
                )}
                {/* UserSubmission */}
                <TableCell>{row.createdBy ? row.createdBy.split('@')[0] : '-'}</TableCell>
                {/* CreatedDate */}
                <TableCell>{PulseOpsFormat.datetoFormat(row.createdDate, 'DD/MM/YYYY HH:mm:ss')}</TableCell>

                {/* Aging */}
                <TableCell>{row.aging}</TableCell>
                {/* LastUpdatedDate */}
                <TableCell>
                  {row.lastUpdateDateAdj
                    ? PulseOpsFormat.datetoFormat(row.lastUpdateDateAdj, 'DD/MM/YYYY HH:mm:ss')
                    : row.lastUpdateDateVer
                      ? PulseOpsFormat.datetoFormat(row.lastUpdateDateVer, 'DD/MM/YYYY HH:mm:ss')
                      : '-'}
                </TableCell>
                {/* LastAssignee */}
                {[TabSearch.TraditionalClaimSearch].includes(selectedTab) && (
                  <TableCell>
                    <Text>{row.assigneeName || '-'}</Text>
                    {row.assignee && row.assignee !== '-' && (
                      <View>
                        <Text>({row.assignee.split('@')[0]})</Text>
                      </View>
                    )}
                  </TableCell>
                )}
                {/* LastUpdatedBy */}
                <TableCell>
                  {row.lastUpdateByAdj
                    ? row.lastUpdateByAdj.split('@')[0]
                    : row.lastUpdateByVer
                      ? row.lastUpdateByVer.split('@')[0]
                      : '-'}
                </TableCell>
              </TableRow>
            ))}
            <TableRow></TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        page={pageNum}
        rowsPerPage={pageSize}
        count={totalItem}
        onPageChange={(e, page) => {
          setPageNum(page)
          queryServiceInquiryList(pageSize, page)
        }}
        onRowsPerPageChange={(e) => {
          setPageSize(Number(e.target.value))
          setPageNum(0)
          queryServiceInquiryList(Number(e.target.value), 0)
        }}
        labelRowsPerPage={t('common:PaginationSize')}
        labelDisplayedRows={({ from, to, count }) => t('common:Pagination', { from, to, count })}
        component={View}
      />
    </View>
  )
}